module.exports = __webpack_public_path__ + "static/media/hot-to-burn-hold-and-spin.ee703255.gif";